module.exports = __webpack_public_path__ + "static/img/ys1.98a2859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因组测序/ys1.jpg
// module id = 8A+E
// module chunks = 16